// extracted by mini-css-extract-plugin
export default {"wrapper":"CRMNewsPage_wrapper__sLnsF"};